import {getEnv, types} from 'mobx-state-tree';
import {Router} from './Router';

const CommonRoutingViewModel = types
    .model('WithRouteParams')
    .volatile(() => ({
        routerParams: null as any,
    }))
    .views((self) => ({
        getRouteParamByName(name: string) {
            return self.routerParams[name];
        },
        get router(): Router {
            return self.routerParams['router'];
        },
    }))
    .actions((self) => ({
        updateRouterParams(params: any) {
            self.routerParams = params;
        },
        afterCreate() {
            const {routerParams} = getEnv(self);
            self.routerParams = routerParams;
        },
    }));

export default CommonRoutingViewModel;
